import { render, staticRenderFns } from "./LocationExternalData.vue?vue&type=template&id=60c1bd7b"
import script from "./LocationExternalData.vue?vue&type=script&lang=js"
export * from "./LocationExternalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports